import {
  UPDATE_LD_FLAGS,
  UPDATE_LD_ID,
  UPDATE_LD_CLIENT,
} from '../actions/types';

const initialState = {
  launchDarklyId: null,
  flags: {},
  storeLdClient: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_LD_FLAGS:
      return {
        ...state,
        flags: {...action.payload}
      };
    case UPDATE_LD_ID:
      return {
        ...state,
        launchDarklyId: action.payload
      };
    case UPDATE_LD_CLIENT:
      return {
        ...state,
        storeLdClient: {...action.payload}
      };
    default:
      return state;
  }
};
